/** Keep ordinary taps distinct from selection holds, including on a busy Android JS thread. */
export const MORPHEME_TILE_DELAY_LONG_PRESS_MS = 500;
